import React from 'react';

export default function Container({ children, className = '' }) {
  return (
    <div className={`with-container ${className}`}>
      { children }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Container.js